import(/* webpackMode: "eager" */ "/vercel/path0/app/resources/faq/page.tsx");
